module.exports = __webpack_public_path__ + "static/media/charles02.e077a193.jpg";